import { API } from '../constants/api-urls';
import axios from '../requester';

export const getBoards = async (params = {}) =>
  axios.get(API.BOARDS_PATH, { params });

export const setDefaultBoard = async (board_id, team_id) =>
  axios.put(
    `${API.BOARDS_PATH}/default${team_id ? `?team_id=${team_id}` : ''}`,
    { board_id }
  );
